export const getStudioPhotoLimit = (tariff: unknown): number => (Number(tariff) === 0 ? 5 : 12)

export const getRequiredStudioPhotoCount = (tariff: unknown): number => (Number(tariff) === 0 ? 3 : 5)

export const getStudioDisplayImages = (images: unknown, tariff: unknown): string[] => {
	if (typeof images !== 'string' || images.trim() === '') return []

	const studioImages = images
		.split(';')
		.map((image) => image.trim())
		.filter(Boolean)

	return studioImages.slice(0, getStudioPhotoLimit(tariff))
}
